var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18,
    fill: "none",
    stroke: "#0088CC",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7418 13.8094C21.089 14.1495 21.6518 14.1495 21.9989 13.8094L22.8519 12.9737L22.8519 24.8065C22.8519 25.2875 23.2498 25.6774 23.7407 25.6774C24.2317 25.6774 24.6296 25.2875 24.6296 24.8065L24.6296 12.9737L25.4826 13.8094C25.8297 14.1495 26.3925 14.1495 26.7396 13.8094C27.0868 13.4693 27.0868 12.9178 26.7396 12.5777L24.3693 10.2551C24.0221 9.91497 23.4593 9.91497 23.1122 10.2551L20.7418 12.5777C20.3947 12.9178 20.3947 13.4693 20.7418 13.8094Z",
    fill: "#0088CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1481 25.0263L16.0011 24.1906C16.3482 23.8505 16.911 23.8505 17.2582 24.1906C17.6053 24.5307 17.6053 25.0822 17.2582 25.4223L14.8878 27.7449C14.5407 28.085 13.9779 28.085 13.6307 27.7449L11.2603 25.4223C10.9132 25.0822 10.9132 24.5307 11.2603 24.1906C11.6075 23.8504 12.1703 23.8505 12.5174 24.1906L13.3704 25.0263L13.3704 13.1935C13.3704 12.7125 13.7683 12.3226 14.2593 12.3226C14.7502 12.3226 15.1481 12.7125 15.1481 13.1935L15.1481 25.0263Z",
    fill: "#0088CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.406632de87761a96769ee2b51306d198.svg";
export { ForwardRef as ReactComponent };